import React from 'react';
import styled from 'styled-components';

import { MarkerPropsNode } from './Marker';

export const TooltipWrapper = styled.div`
  padding: 10px;
  position: absolute;
  width: auto;
  white-space: nowrap;
  word-wrap: no-wrap;
  box-shadow: 1px 1px 20px #aaa;
  border-radius: 5px;
  background-color: #fff;
  top: -70px;
  margin-left: 50px;
  transform: translate(-50%);
  transform-style: preserve-3d;
  z-index: 200;
  font-size: 12px;
  display: none;
  :after {
    content: '';
    position: absolute;
    display: block;
    width: 10px;
    height: 10px;
    transform-origin: 50% 50%;
    transform: rotate(45deg) translateX(-50%);
    background-color: #fff;
    left: 50%;
    top: 57px;
    z-index: 400;
  }
  :before {
    content: '';
    display: block;
    position: absolute;
    width: 10px;
    height: 10px;
    transform-origin: 50% 50%;
    transform: rotate(45deg) translateX(-50%) translateZ(-1px);
    background-color: #fff;
    left: 50%;
    top: 58px;
    z-index: -1;
    box-shadow: -1px -1px 20px #aaa;
  }
`;

interface TooltipProps {
  node: MarkerPropsNode;
}

export const Tooltip = ({ node }: TooltipProps) => {
  return (
    <TooltipWrapper>
      {node.name}, {node.address}
      <br />
      tel. {node.firstPhone}
      <br />
      tel. {node.secondPhone}
    </TooltipWrapper>
  );
};
